export default "__VITE_ASSET__Cwy4kz4h__"